module.exports = __webpack_public_path__ + "49204d5b3d8510eb3dd7bbb21898a3a2.png";